<script lang="ts">
  import type { Match } from '../lib/match.svelte';
  import { figures, oversFrom } from '../lib/commentary';

  interface Props {
    match: Match;
  }
  let { match }: Props = $props();

  const r = $derived(match.firstInnings);
  const top = $derived(
    r ? [...r.batting].filter((b) => b.balls > 0).sort((a, b) => b.runs - a.runs).slice(0, 2) : [],
  );
  const best = $derived(
    r ? [...r.bowling].filter((b) => b.balls > 0).sort((a, b) => b.wickets - a.wickets || a.runs - b.runs)[0] : null,
  );
</script>

<section class="screen active" aria-label="Innings break">
  <div class="body" style="text-align:center">
    <p class="eyebrow" style="text-align:left">Innings break</p>
    {#if r}
      <div class="verdict">
        <div class="big tabular">{r.runs}/{r.wickets}</div>
        <p class="muted">
          {match.youBatFirst ? match.youName : match.opponent.name} · {oversFrom(r.legalBalls)} overs
        </p>
      </div>

      <div class="card" style="text-align:left">
        <p class="eyebrow" style="margin:0 0 3px">Target</p>
        <p style="margin:0">
          <strong class="tabular">{r.runs + 1}</strong> to win, at
          <span class="tabular">{((r.runs + 1) / 20).toFixed(2)}</span> an over.
        </p>
      </div>

      <p class="eyebrow" style="margin-top:var(--space-5);text-align:left">Top of the innings</p>
      {#each top as b (b.player.id)}
        <div class="card" style="text-align:left">
          <strong>{b.player.name}</strong>
          <span class="muted tabular">{b.runs} ({b.balls})</span>
        </div>
      {/each}
      {#if best}
        <div class="card" style="text-align:left">
          <strong>{best.player.name}</strong>
          <span class="muted tabular">
            {figures(best.balls, best.runs, best.wickets, best.maidens)}
          </span>
        </div>
      {/if}
    {/if}
  </div>

  <div class="actions">
    <button class="btn-primary" onclick={() => match.startSecondInnings()}>
      {match.youBatFirst ? 'Take the field' : 'Start the chase'}
    </button>
  </div>
</section>
